import React, { useState, useEffect, useContext } from "react";
import { LoginContext } from "../../DataStore";
import { ContractListItemHelper } from "../../backend/domain";
import moment from "moment";
import AktionenContractListHeader from "./PromotionsContractListHeader";
import AktionenContractListTableHeader from "./PromotionsContractListTableHeader";
import ContractListTableFooter from "../../contractslist/ContractListTableFooter";
import ContractListTablePagination from "../../contractslist/ContractListTablePagination";
import AktionenContractRows from "./PromotionsContractRows";
import { loadAktionenContractsList, loadCSVLineForAktionenContract } from "../../backend/AktionenService";
import { downloadCSVFile } from "../../utils/Utils";
import "../promotions.css"
import LoadingOverlay from "../../components/LoadingOverlay";

export const csvAktionenDownloadHeader =
  "Partnernummer Vermittler#Partnernummer des Kunden#Titel#Vorname#Nachname#Adresse#PLZ#Ort#Geburtsdatum#Telefonnummer#Mobilnummer#Email#Branding des Vertrags#Gruppenzuteilung#Geschäftsfallnummer#Vertragsnummer#Start der Finanzierung#Vertragsende#Produktbezeichnung#Restwert#Rate#Laufzeit in Monaten#Kaufpreis#Anzahlung#Depot#Sollzinssatz#Effektivzinssatz#fix/variabel#Leasingfähigkeit#Fahrgestellnummer#Erstzulassung#NatCode#Type#Nachname des Verkäufers#Vorname des Verkäufers#Fahrzeugname#Erstzulassung#Kilometerstand#Kaufpreis#Angebot gültig bis#Sonderausstattung #Bild#Bildtyp#Händlername#Adresse#PLZ#Ort#Email#Telefonnummer#Händlerlogo#Erstellungsdatum\n";

const AktionenContractList = ({ archive = false }) => {
  const {
    selectedDealer,
   } = useContext(LoginContext);

  const [overlayActive, setOverlayActive] = useState(false);
  const [overlayText, setOverlayText] = useState("Daten werden geladen...");

  // contracts list
  const [contracts, setContracts] = useState([]);
  const [originalContracts, setOriginalContracts] = useState([]);
  const [contractsForDownload, setContractsForDownload] = useState([]);

  // sorting
  const [currentSortKey, setCurrentSortKey] = useState("aktion");
  const [currentSortDirection, setCurrentSortDirection] = useState("ASC");

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  // filter
  const [filter, setFilter] = useState({
    name: null,
    contractNumber: null,
    endDate: null,
    offerStatus: null,
    advertStatus: null,
  });

  // navigate to another page
  const navigateToPage = (page) => {
    setCurrentPage(page);
  };

  // get just the contracts for current page
  const getContractsForCurrentPage = () => {
    return contracts.slice(
      pageSize * (currentPage - 1),
      pageSize * currentPage
    );
  };

  const sortBy = (sortKey) => {
    // if same sort key than just switch direction
    var sortDirection;
    if (sortKey === currentSortKey) {
      sortDirection = currentSortDirection === "ASC" ? "DESC" : "ASC";
    } else {
      // switch sort key and set direction by default auf asc
      sortDirection = "ASC";
    }
    setCurrentSortKey(sortKey);
    setCurrentSortDirection(sortDirection);
    var comparator = ContractListItemHelper.getSortComparator(
      sortKey,
      sortDirection
    );
    const sortedContracts = contracts.sort(comparator);
    setContracts(sortedContracts);
    setOriginalContracts(contracts);
  };
  const handleRueckmeldungBisFilterChanged = ( date) => {
    filter.validUntil = date;
    filterAndSortedContractsList();
  };
  const filterAndSortedContractsList = () => {
    var filteredContracts = originalContracts;
    // filter by name if available
    if (filter.name) {
      filteredContracts = filteredContracts.filter((contract) =>
        ContractListItemHelper.getCustomerFullName(contract)
          .trim()
          .toLowerCase()
          .includes(filter.name.trim().toLowerCase())
      );
    }
    if (filter.salesPersonName) {
      filteredContracts = filteredContracts.filter((contract) =>
        contract.salesPersonName
          .trim()
          .toLowerCase()
          .includes(filter.salesPersonName.trim().toLowerCase())
      );
    }
    if (filter.aktionen) {
      filteredContracts = filteredContracts.filter((contract) =>{
        return contract.promotion.name
          .trim()
          .toLowerCase()
          .includes(filter.aktionen.trim().toLowerCase());
      }
      );
    }
    if (filter.contractNumber) {
      filteredContracts = filteredContracts.filter((contract) =>
        contract.number.toString().startsWith(filter.contractNumber)
      );
    }
    if (filter.product) {
      filteredContracts = filteredContracts.filter((contract) =>
        contract.productName
          .toLowerCase()
          .includes(filter.product.toLowerCase())
      );
    }
    if (filter.offerStatus) {
      switch (filter.offerStatus) {
        case "offen":
          filteredContracts = filteredContracts.filter(
            (contract) => {
              if(contract.promotion.type === "PARTICIPATION"){
                return contract.participation === "NOT_SET";
              } else return !contract.offerAvailable;
            }
          );
          break;
        default :
          filteredContracts = filteredContracts.filter(
            (contract) =>
              {
                if (contract.promotion.type === "PARTICIPATION") {
                  return contract.participation !== "NOT_SET";
                } else return contract.offerAvailable;
              }
          );
          break;
      }
    }
    //Values: alle,angebot,info,advBlock    
    if (filter.validUntil) {
      filteredContracts = filteredContracts.filter(
        (contract) =>
          moment(contract.promotion.validUntil, "DD.MM.YYYY").toDate() >=
          filter.validUntil
      );
    }
    setContracts(filteredContracts);
  };
  const handleFilterChanged = (e) => {
    switch (e.target.name) {
      case "nameFilter":
        filter.name = e.target.value;
        break;
      case "contractNrFilter":
        filter.contractNumber = e.target.value;
        break;
      case "salesPersonNameFilter":
        filter.salesPersonName = e.target.value;
        break;
      case "residualValueFilter":
        filter.residualValue = e.target.value;
        break;
      case "filterOfferStatus":
        filter.offerStatus = e.target.value;
        break;
      case "aktionFilter":
        filter.aktionen = e.target.value;
        break;
      case "productFilter":
        filter.product = e.target.value;
        break;
    }
    filterAndSortedContractsList();
  };
  // calculate if all the contracts are selected for download
  const isContractsForDownloadChecked = () => {
    if (contracts.length === 0) return false;

    var allSelected = true;

    for (
      var i = pageSize * (currentPage - 1);
      i < contracts.length && i < pageSize * currentPage;
      i++
    ) {
      // add all page to the selected list
      var numberStr = "" + contracts[i].number;
      if (allSelected && !contractsForDownload.includes(numberStr)) {
        allSelected = false;
      }
    }
    return allSelected;
  };
  const handleDownloadChange = (e) => {
    var selectedArray = [...contractsForDownload];
    if (e.target.name === "downloadAll") {
      if (e.target.checked) {
        for (
          var i = pageSize * (currentPage - 1);
          i < pageSize * currentPage && i < contracts.length;
          i++
        ) {
          // add all page to the selected list
          var numberStr = "" + contracts[i].number;
          if (!selectedArray.includes(numberStr)) {
            selectedArray.push(numberStr);
          }
        }
      } else {
        // remove all from selection
        selectedArray = [];
      }
    } else {
      if (e.target.checked) {
        if (!selectedArray.includes(e.target.value)) {
          selectedArray.push(e.target.value);
        }
      } else {
        var index = selectedArray.indexOf(e.target.value);
        if (index >= 0) {
          selectedArray.splice(index, 1);
        }
      }
    }
    setContractsForDownload(selectedArray);
  };
  
  const loadAKtionenContracts = async () => {
    // load the contracts into "contracts" and sort it by name
    if (selectedDealer !== null && selectedDealer !== undefined) {
      setOverlayText("Es wird nach Verträgen gesucht.");
      setOverlayActive(true);
      try {
        const contracts = await loadAktionenContractsList(
          selectedDealer,
          archive
        );
        setContracts(
          contracts.sort(
            ContractListItemHelper.getSortComparator(
              currentSortKey,
              currentSortDirection
            )
          )
        );
        setOriginalContracts(contracts);
      } finally {
        setOverlayActive(false);
      }
    }
  };

  useEffect(() => {
    loadAKtionenContracts();
  }, [selectedDealer]);

  // generate 1 csv line for a contract
  const generateCSVLine = async (contractNr) => {
    // if it was selected than create a csv line
    return await loadCSVLineForAktionenContract(contractNr);
  };
  const doDownloadContracts = async () => {
    // add header line
    var csv = csvAktionenDownloadHeader;
    // add one row for each
    for (let i = 0; i < contractsForDownload.length; i++) {
      csv += await generateCSVLine(contractsForDownload[i]);
    }
    downloadCSVFile("scb_vertraege.csv", csv);
  };
  // generates the csv file and downloads it
  const downloadSelectedContracts = () => {
    setOverlayActive(true);
    setOverlayText("Datei mit Verträge wird vorbereitet!");
    doDownloadContracts()
      .then(() => {
        setOverlayActive(false);
      })
      .catch((error) => {
        setOverlayActive(false);
      });
  };
  return (
    <LoadingOverlay active={overlayActive} spinner text={overlayText}>
      <div className="pt-3">
        <AktionenContractListHeader archive={archive} />
        <div className="aktionen-list-panel">
          <table className="table table-sm mt-3 table-contracts">
            <AktionenContractListTableHeader
              currentSortKey={currentSortKey}
              currentSortDirection={currentSortDirection}
              sortBy={sortBy}
              handleFilterChanged={handleFilterChanged}
              handleRueckmeldungBisFilterChanged={
                handleRueckmeldungBisFilterChanged
              }
              dateFilter={filter.endDate}
              handleDownloadAllChange={handleDownloadChange}
              contractsForDownloadChecked={isContractsForDownloadChecked()}
            />

            <AktionenContractRows
              contractsForPage={getContractsForCurrentPage()}
              contractsForDownload={contractsForDownload}
              handleDownloadChange={handleDownloadChange}
              archive={archive}
            />
            <tfoot>
              <tr>
                <td
                  style={{ paddingLeft: "0px", paddingRight: "0px" }}
                  colSpan="8"
                >
                  <ContractListTableFooter
                    numberOfElements={contracts.length}
                    pageSize={pageSize}
                    pageNumber={currentPage}
                  />
                  <ContractListTablePagination
                    currentPage={currentPage}
                    pageCount={Math.ceil(contracts.length / pageSize)}
                    navigateToPage={navigateToPage}
                    downloadClicked={downloadSelectedContracts}
                    contractsForDownload={contractsForDownload}
                  />
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </LoadingOverlay>
  );
};

export default AktionenContractList;
